import toast, { TMessage, Toaster } from 'core/components/toast'
import style from './style.module.scss'
import cls from 'classnames'
import { ErrorNotifier } from 'core/hooks/InitApp/useAxiosResponseErrorHandler'

export type TNotification = {
  type?: 'info' | 'success' | 'error' | 'warning'
} & TMessage

const notification = {
  open(message: TNotification) {
    return toast(message)
  },
  success(message: TNotification) {
    return toast({
      ...message,
      type: 'success',
    })
  },
  error(message: TNotification) {
    return toast({
      ...message,
      type: 'error',
    })
  },
  warning(message: TNotification) {
    return toast({
      ...message,
      type: 'warning',
    })
  },
  info(message: TNotification) {
    return toast({
      ...message,
      type: 'info',
    })
  },
}

type TNotificationHolderProps = {
  maxNotificationLength?: number
}

export const NotificationHolder = ({ maxNotificationLength = 4 }: TNotificationHolderProps) => {
  const type = {
    success: <i className="iconfont iconchenggongtishi mr-4 c-success" />,
    warning: <i className="iconfont icontixing mr-4 c-warning" />,
    error: <i className="iconfont iconshibaitishi mr-4 c-error" />,
    info: <i className="iconfont icontishi-14 mr-4 c-info" />,
  }
  return (
    <Toaster
      render={(messages) => {
        return (
          <div className={style.notifications}>
            <div
              className={cls({
                [style.group]: messages.length >= maxNotificationLength,
              })}
            >
              {[...messages]
                .reverse()
                .filter((_, index) => index < maxNotificationLength)
                .map((message) => {
                  return (
                    <div key={message._id} className={style.notificationBox}>
                      <div className={style.notification}>
                        {type[message.type]}
                        <div>
                          {message.title && <h3 className={style.title}>{message.title}</h3>}
                          <div className={style.contentText}>{message.message}</div>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        )
      }}
    />
  )
}

export class PCErrorNotifier implements ErrorNotifier {
  notify(message: string) {
    notification.error({
      message,
    })
  }
}

export default notification
